import {
	RECEIVE_UPDATE_LAYOUT,
	REQUEST_UPDATE_LAYOUT,
	UPDATE_LAYOUT_ERROR,
	REQUEST_ADD_LAYOUT,
	RECEIVE_ADD_LAYOUT,
	ADD_LAYOUT_ERROR,
	REQUEST_DELETE_LAYOUT,
	RECEIVE_DELETE_LAYOUT,
	DELETE_LAYOUT_ERROR,
} from '../actions/layoutActionsRedux';
import {
	REQUEST_ADD_VIEW,
	RECEIVE_ADD_VIEW,
	ADD_VIEW_ERROR,
	REQUEST_UPDATE_VIEW,
	RECEIVE_UPDATE_VIEW,
	UPDATE_VIEW_ERROR,
	RECEIVE_VIEWS,
	REQUEST_VIEWS,
	VIEWS_ERROR,
	RECEIVE_DELETE_VIEW,
	REQUEST_DELETE_VIEW,
	DELETE_VIEW_ERROR,
	REQUEST_ALL_VIEW_ELEMENTS,
	RECEIVE_ALL_VIEW_ELEMENTS,
	ALL_VIEW_ELEMENTS_ERROR,
	REQUEST_EXTENDED_VIEW_ELEMENTS,
	RECEIVE_EXTENDED_VIEW_ELEMENTS,
	EXTENDED_VIEW_ELEMENTS_ERROR,
} from '../actions/viewActionsRedux';

import { RECEIVE_ACTIVE_MODEL } from '../actions/activeModelActions';

import { RECEIVE_LOGOUT_USER } from '../actions/activeUserActions';
import {
	RECEIVE_UPDATE_PROJECT_VIEW,
	REQUEST_UPDATE_PROJECT_VIEW,
	UPDATE_PROJECT_VIEW_ERROR,
} from '../actions/projectActionsRedux';

const initialViewsState = {
	isFetching: false,
	items: [],
	error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const viewsReducer = (state = initialViewsState, action) => {
	switch (action.type) {
		case REQUEST_VIEWS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_VIEWS:
			return { ...state, items: action.payload, isFetching: false };
		case VIEWS_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_UPDATE_LAYOUT:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_UPDATE_LAYOUT:
			const updatedViews = state.items.map((view) => ({
				...view,
				layouts: view.layouts.map((layout) => (layout._id === action.payload._id ? action.payload : layout)),
			}));
			return { ...state, items: updatedViews, isFetching: false };
		case UPDATE_LAYOUT_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_ADD_VIEW:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_ADD_VIEW:
			// sets new state and fetching ended
			return {
				...state,
				items: [...state.items, action.payload],
				isFetching: false,
				error: null,
			};
		case ADD_VIEW_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_UPDATE_VIEW:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_UPDATE_VIEW:
			// sets new state and fetching ended
			return {
				...state,
				items: state.items.map((view) => (view._id === action.payload._id ? action.payload : view)),
				isFetching: false,
				error: null,
			};
		case UPDATE_VIEW_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_UPDATE_PROJECT_VIEW:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_UPDATE_PROJECT_VIEW:
			// sets new state and fetching ended
			return {
				...state,
				items: state.items.map((view) => (view._id === action.payload._id ? action.payload : view)),
				isFetching: false,
				error: null,
			};
		case UPDATE_PROJECT_VIEW_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_ADD_LAYOUT:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_ADD_LAYOUT:
			// sets new state and fetching ended
			if (action.payload.templateLayout) {
				return state;
			}
			return {
				...state,
				items: state.items.map((view) => {
					if (view._id === action.viewId) {
						if (action.layoutType === 'normal') return { ...view, layouts: [...view.layouts, action.payload] };
						if (action.layoutType === 'start') return { ...view, startLayouts: [...view.startLayouts, action.payload] };
					} else {
						return view;
					}
				}),
				isFetching: false,
				error: null,
			};
		case ADD_LAYOUT_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_DELETE_LAYOUT:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_DELETE_LAYOUT:
			// sets new state and fetching ended
			if (action.payload.templateLayout) {
				return state;
			}
			return {
				...state,
				items: state.items.map((view) => {
					if (view._id === action.viewId) {
						if (action.layoutType === 'normal')
							return {
								...view,
								layouts: view.layouts.filter((layout) => layout._id !== action.payload._id),
							};
						if (action.layoutType === 'start')
							return {
								...view,
								startLayouts: view.startLayouts.filter((layout) => layout._id !== action.payload._id),
							};
					} else {
						return view;
					}
				}),
				isFetching: false,
				error: null,
			};
		case DELETE_LAYOUT_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_DELETE_VIEW:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_DELETE_VIEW:
			// sets new state and fetching ended
			return {
				...state,
				items: state.items.filter((view) => view._id !== action.payload._id),
				isFetching: false,
				error: null,
			};
		case DELETE_VIEW_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_ALL_VIEW_ELEMENTS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_ALL_VIEW_ELEMENTS:
			// sets new state and fetching ended
			return {
				...state,
				items: state.items.map((view) =>
					view._id === action.payload.viewId
						? {
								...view,
								allElements: action.payload.allElements,
								layeredElements: action.payload.layeredElements,
						  }
						: view
				),
				isFetching: false,
				error: null,
			};
		case ALL_VIEW_ELEMENTS_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_EXTENDED_VIEW_ELEMENTS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_EXTENDED_VIEW_ELEMENTS:
			// sets new state and fetching ended
			return {
				...state,
				items: state.items.map((view) => {
					if (view._id === action.payload.viewId) {
						if (!view.extendedViewElementsList) {
							view.extendedViewElementsList = [];
						}
						for (const viewElement of action.payload.extendedViewElementsList) {
							if (!view.extendedViewElementsList.find((el) => el._id === viewElement._id)) {
								view.extendedViewElementsList.push(viewElement);
							}
						}
						return view;
					} else {
						return view;
					}
				}),
				isFetching: false,
				error: null,
			};
		case EXTENDED_VIEW_ELEMENTS_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case RECEIVE_ACTIVE_MODEL:
			if (state.items && state.items[0] && state.items[0].model === action.payload._id) {
				return state;
			}
			return initialViewsState;
		case RECEIVE_LOGOUT_USER:
			// sets new state and fetching ended
			return { ...initialViewsState, isFetching: false };
		default:
			return state;
	}
};
